/**
 * Created by thm on 19.07.2016.
 */
import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { LanguageService } from '../i18n/language.service';
import { I18N } from './modal-dialog.i18n';

/**
 * Einfacher Wrapper um <code>&lt;common-form-modal-dialog-wrapper&gt;</code>,
 * der lediglich einen Textblock im modalen Dialog anzeigen kann. Die Komponente
 * bietet einen "Abbrechen" und einen "Akzeptieren" Button an.
 */
@Component({
    selector: 'common-form-modal-dialog',
    template: `
    <common-form-modal-dialog-wrapper [header]="header" (close)="closeModalMode()">
        {{txt}}
        <common-form-buttons>
            <common-form-button (clickEvt)="closeModalMode()" value="{{i18n.cancel}}"></common-form-button>
            <common-form-button (clickEvt)="agree()" value="{{i18n.agree}}" [isPrimary]="true"></common-form-button>
        </common-form-buttons>
    </common-form-modal-dialog-wrapper>
        `
})
export class ModalDialogComponent implements OnDestroy {

    @Input() header = ''; // Überschrift
    @Input() txt = '';    // Modal Dialog Text

    @Output() agreeMethodCall = new EventEmitter<boolean>();

    /**
     * Da die den Modal Dialog öffnende Komponente diese über ngIf auch wieder schließen muss, gibt es
     * dafür einen extra EventEmitter der eine "close"-Methode in der Caller-Komponente aufruft, die
     * wiederum dafür sorgt, dass auf dem gleichen Weg wie der Dialog geöffnet wurde, dieser auch
     * wieder geschlossen wird.
     * Das Schließen des Modal Dialogs aus der Dialog-Komponente heraus führt dazu, dass zwar der Dialog
     * verschwindet, aber angularJS immer noch "denkt" die Komponente wäre geöffnet. Ein erneutes Öffnen
     * funktioniert daher nicht.
     * @type {EventEmitter}
     */
    @Output() closeMethodCall = new EventEmitter();

    i18n: any;

    private readonly languageSubscription: Subscription;

    constructor(private languageService: LanguageService) {
        this.languageSubscription = languageService.registerForLanguageChanged(this, 'i18n', I18N);
    }

    closeModalMode() {
        this.closeMethodCall.emit({});
    }

    agree() {
        this.agreeMethodCall.emit(false);
    }

    ngOnDestroy(): void {
        if (this.languageSubscription) this.languageSubscription.unsubscribe();
    }
}
